/*
 *  I04CALCULGDETAItemCalcul.js
 *
 *  Created by Sébastien Hecart on 2019-05-14 19:22:59 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchCoeffGDeta, fetchRVitrage } from '@batical/data/src'
import { I04CALCULGDETAItem_State, RCoeffGDeta_Type, RVitrage_Type } from '@batical/types/src'

function I04CALCULGDETAItem_docalcul(state: I04CALCULGDETAItem_State, _isWeb: boolean = false) {
  // let selectedm_lourd_nature = fetchCoeffGDetaMurs(m_lourd_nature)
  // let selectedvitrage_uuid = fetchCoeffGDetaTypeVitrage(vitrage_uuid)
  // let selectediso_nature = fetchCoeffGDetaMurs(iso_nature)
  // let selectedorientation_uuid = fetchCoeffGDetaOrientation(orientation_uuid)
  //TODO CALCUL

  const {
    category,
    m_lourd_nature,
    in_m_lourd_epaisseur,
    vitrage_uuid,
    iso_nature,
    in_iso_epaisseur,
    in_paroi_position,
    in_plafond_position,
    in_plancher_position
  } = state

  if (category === 'vitrages') {
    //gdeta is differente
    const gDeta: RVitrage_Type = fetchRVitrage(vitrage_uuid)
    if (gDeta) {
      state.res_ucalc = gDeta.u
      state.in_ucorr = gDeta.u
    }
    return state
  }
  const gDeta: RCoeffGDeta_Type = fetchCoeffGDeta(m_lourd_nature)

  if (gDeta) {
    if (category === 'facades' || category === 'plafonds' || category === 'planchers') {
      const gDetaIsolant: RCoeffGDeta_Type = fetchCoeffGDeta(iso_nature)
      //ROUND(IF(F32+J32+L32=0;0;1/(F32+J32+L32));3)
      //const F32 = gDeta.lambda === 0 ? 0 : in_m_lourd_epaisseur / 100 / gDeta.lambda;
      let sum = 0
      if (gDeta.lambda !== 0) {
        sum += in_m_lourd_epaisseur / 100 / gDeta.lambda
      }
      if (gDetaIsolant && gDetaIsolant.lambda !== 0) {
        sum += in_iso_epaisseur / 100 / gDetaIsolant.lambda
      }

      if (category === 'facades') {
        switch (in_paroi_position) {
          case 0:
            sum += 0.17
            break
          case 1:
            sum += 0.26
            break
          case 2:
            sum += 0.26
            break
        }
      }
      if (category === 'plafonds') {
        switch (in_plafond_position) {
          case 'pos_plafond_0':
            sum += 0.14
            break
          case 'pos_plafond_1':
            sum += 0.2
            break
          case 'pos_plafond_2':
            sum += 0.2
            break
        }
      }
      if (category === 'planchers') {
        switch (in_plancher_position) {
          case 'pos_plancher_0':
            sum += 0.21
            break
          case 'pos_plancher_1':
            sum += 0.34
            break
          case 'pos_plancher_2':
            sum += 0.21
            break
          case 'pos_plancher_3':
            sum += 0.34
            break
        }
      }

      if (sum === 0) {
        state.res_ucalc = 0
        state.in_ucorr = 0
      } else {
        state.res_ucalc = 1 / sum
        state.in_ucorr = Math.trunc(state.res_ucalc * 10000) / 10000 //because display is trunc a 3, but keep real value for calcul
      }
    } else if (category === 'portes') {
      state.res_ucalc = gDeta.lambda
      state.in_ucorr = gDeta.lambda
    }
    return state
  }
  state.invalidated = false
  return state
}

export default I04CALCULGDETAItem_docalcul
